import PropTypes from 'prop-types'
import qs from 'qs'
import {withRouter} from 'react-router-dom'

const QueryParams = ({children, location, history}) => {
  const queryParams = qs.parse(location.search.replace(/^\?/, ''))

  const setQueryParams = (params) => {
    const to = history.createHref({
      pathname: location.pathname,
      search: qs.stringify({
        ...queryParams,
        ...params,
      })
    })

    history.push(to)
  }

  return children({queryParams, setQueryParams})
}

QueryParams.propTypes = {
  children: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default withRouter(QueryParams)
